










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Global, Reports } from '@/store';

@Component({})
class Sensors extends Vue {
    @Global.State('lang') lang;
    @Global.Mutation('setDeviceClicked') setDeviceClicked;
    @Global.Mutation('setPageTitle') setPageTitle;
    @Reports.Getter('motion_sensor_and_meta_device_map') motion_sensor_and_meta_device_map;

    mounted(){
        this.setPageTitle('Motion Sensor');
    }

    sensorClicked(device){
        this.$router.push('/');
        this.setDeviceClicked(device.id);
    }

    getModel(meta_device) {
        return meta_device && meta_device.model ? meta_device.model : 'N/A';
    }

    getManufacturer(meta_device) {
        return meta_device && meta_device.manufacturer ? meta_device.manufacturer : 'N/A';
    }

    getInterfaceData(meta_device) {
        return meta_device && meta_device.interface ? meta_device.interface : 'N/A';
    }
}

export default Sensors;
